import "./FormFieldWithLabel.scss";
import { ReactComponent as ErrorSVG } from "../../assets/images/error.svg";
import FormField from "../FormField/FormField";

export default function FormFieldWithLabel({
  label,
  type,
  id,
  placeholder,
  value,
  onChange,
  errorMessage,
  onFocus,
  onBlur,
  disabled,
  onClick,
  max,
  r,
  c,
  required = false,
}) {
  return (
    <div className="form_field_with_label">
      <span
        className={`form_field_with_label__text ${required ? "required-field" : ""}`}
      >
        {label}
      </span>
      {errorMessage && (
        <div className="error_message_container">
          {errorMessage ? <ErrorSVG /> : null}
          <span className="error_message_container__text">{errorMessage}</span>
        </div>
      )}
      <FormField
        label={label}
        type={type}
        id={id}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onFocus={onFocus}
        onBlur={onBlur}
        disabled={disabled}
        max={max}
        onClick={onClick}
        r={r}
        c={c}
      />
    </div>
  );
}
